export enum OfferContractPaymentTypeEnum {
  WIRE_TRANSFER = 'WIRE_TRANSFER',
  MEMBERSHIP_BALANCE = 'MEMBERSHIP_BALANCE',
}
